export default __webpack_public_path__ + "static/3-4ac5bc800fcfea1379458ce9489e8e98.jpg";